import { 
  GET_ALERTS_BY_VM_ID, 
  GET_ALERT_SUMMARY, 
  GET_ALERT_HEATMAP 
} from "../../infrastructure/graphql/alertQueris";
import { client } from "../../infrastructure/graphql/client";

export class AlertService {
  async getAlertsByVmId(vmId, index) {
    try {
      const result = await client.query({
        query: GET_ALERTS_BY_VM_ID,
        variables: { vmId, index },
        fetchPolicy: "network-only",
      });

      const response = result.data?.alertsByVmId;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get alerts by VM ID error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getAlertSummary(vmId, startDate, endDate) {
    try {
      const result = await client.query({
        query: GET_ALERT_SUMMARY,
        variables: { vmId, startDate, endDate },
        fetchPolicy: "network-only",
      });

      const response = result.data?.alertSummary;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get alert summary error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getAlertHeatmap(vmId) {
    try {
      const result = await client.query({
        query: GET_ALERT_HEATMAP,
        variables: { vmId },
        fetchPolicy: "network-only",
      });

      const response = result.data?.alertHeatmap;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get alert heatmap error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}